import { render, staticRenderFns } from "./DebugFetch.vue?vue&type=template&id=4d0282bc&scoped=true&lang=pug&"
import script from "./DebugFetch.vue?vue&type=script&lang=js&"
export * from "./DebugFetch.vue?vue&type=script&lang=js&"
import style0 from "./DebugFetch.vue?vue&type=style&index=0&id=4d0282bc&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0282bc",
  null
  
)

export default component.exports